import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import {
  TIPO_DOCUMENTO_ENDPOINT,
} from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    TIPO_DOCUMENTO_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    TIPO_DOCUMENTO_ENDPOINT,
    id,
  ]);
}

export async function fetchCadastroCliente() {
  const queryParams = [
      {
          name: 'cadastroCliente',
          value: 'true',
      }
  ];

  return doGetQCXRequest(
    [TIPO_DOCUMENTO_ENDPOINT, 'search'],
    queryParams
  );
}

export async function register(data, queryParams = []) {
  return doPostQCXRequest(
    [TIPO_DOCUMENTO_ENDPOINT],
    data,
    queryParams
  );
}

export async function save(data, queryParams = []) {
  return doPutQCXRequest(
    [TIPO_DOCUMENTO_ENDPOINT],
    data,
    queryParams
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [TIPO_DOCUMENTO_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [TIPO_DOCUMENTO_ENDPOINT],
    id
  );
}
